module.exports = fox._r("images/bg/play.png", __webpack_public_path__ + "images/bg/play.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/bg/play.png
// module id = 1015
// module chunks = 4